import cx from 'classnames';
import { useDraggable } from '@dnd-kit/core';
import styles from './styles.scss';
/* eslint-disable react/prop-types */ // TODO: add props

const Draggable = ({
  id,
  annotation,
  imageWidth,
  imageHeight,
  isInDropzone,
  imageUrl,
  isCorrect,
  shouldDisableDnD = false,
}) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
    disabled: shouldDisableDnD,
  });

  const { geometry } = annotation;

  const xPos = `${(imageWidth / 100) * geometry.x}px`;
  const yPos = `${(imageHeight / 100) * geometry.y}px`;
  const width = `${(imageWidth / 100) * geometry.width}px`;
  const height = `${(imageHeight / 100) * geometry.height}px`;
  const backgroundPositionX = `${(imageWidth / 100) * geometry.x * -1}px`;
  const backgroundPositionY = `${(imageHeight / 100) * geometry.y * -1}px`;
  const backgroundSize = `${imageWidth}px ${imageHeight}px`;
  const backgroundImage = `url("${imageUrl}")`;

  const draggableImageStyle = {
    backgroundImage,
    backgroundPosition: `${backgroundPositionX} ${backgroundPositionY}`,
    backgroundRepeat: `no-repeat`,
    backgroundSize,
    width,
    height,
  };

  const dragStyle =
    (transform && {
      transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      zIndex: 4, // When being dragged, draggables are above everything
    }) ||
    {};

  const style = isInDropzone
    ? {
        ...draggableImageStyle,
        ...dragStyle,
      }
    : {
        ...draggableImageStyle,
        position: 'absolute',
        top: yPos,
        left: xPos,
        zIndex: 2,
        ...dragStyle,
      };

  return (
    <div
      key={id}
      ref={setNodeRef}
      style={style}
      {...listeners}
      {...attributes}
      className={cx(styles.cursor, {
        [styles.disabledCursor]: shouldDisableDnD,
        [styles.isIncorrect]: isCorrect === false, // must explicitly be false as we don't want null to render a highlight
        [styles.isCorrect]: isCorrect,
      })}
    />
  );
};

export default Draggable;
